/**
 * GET /lessons/club/:clubId/instructors — who a member can book a DIRECT
 * lesson with at this club. [BUT-843, ours]
 *
 * Chain is `[extractTenantId] + optionalAuth`, so `X-Tenant-Id` is mandatory
 * and its absence is a 400; a club outside the resolved tenant answers 404.
 * An empty `instructors` array is a legitimate answer, not an error — the
 * server filters to a live config + `available = true`.
 *
 * @module lessons/api/listClubInstructors
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { ClubInstructor } from '../types';

export function listClubInstructors(params: {
  clubId: number;
  tenantHandle: string;
}): Promise<ApiResult<{ instructors: ClubInstructor[] }>> {
  return apiClient.get<{ instructors: ClubInstructor[] }>(
    `/lessons/club/${params.clubId}/instructors`,
    { clubId: params.clubId, tenantHandle: params.tenantHandle },
  );
}
